import {inject, Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {StorageService} from "../../services/storage/storage.service";
import {OrgDto} from "../dto/org.dto";
import {UrlBuilder} from "../item/url.item";
import {WrapperDto} from "../dto/wrapper.dto";
import {map} from "rxjs/operators";
import {VatRateDto} from "../dto/vat-rate.dto";
import {KeyValueDto} from "../dto/key-value.dto";
import {VoidDto} from "../dto/void.dto";
import {Observable} from "rxjs";

@Injectable({providedIn: 'root'})
export class VatRateRepo {

  private readonly currentStorageKeyPrefix = 'vatrate:current:';
  private readonly currentRead = '/v1/org/{orgId}/vat/current';
  private readonly allRead = '/v1/org/{orgId}/vat/all';
  private readonly futureCreate = '/v1/org/{orgId}/vat';
  private readonly futureDelete = '/v1/org/{orgId}/vat/{id}/delete';
  private readonly typeRead = '/v1/org/{orgId}/vat/type';

  private readonly http: HttpClient = inject(HttpClient);
  private readonly storageService: StorageService = inject(StorageService);

  // noinspection JSUnusedGlobalSymbols
  public readCurrent(org: OrgDto): Observable<WrapperDto<VatRateDto>> {
    const url = UrlBuilder.builder().addPath(this.currentRead).addParam('orgId', org.id).build();
    const key = this.currentStorageKeyPrefix + org.id;
    return this.storageService.cache(key, () => this.http.get<WrapperDto<VatRateDto>>(url.getUrl(), url.getOptions()))
      .pipe(map((res) => new WrapperDto(res)));
  }

  public readAll(org: OrgDto): Observable<WrapperDto<VatRateDto>> {
    const url = UrlBuilder.builder().addPath(this.allRead).addParam('orgId', org.id).build();
    return this.http.get<WrapperDto<VatRateDto>>(url.getUrl(), url.getOptions())
      .pipe(map((res) => new WrapperDto(res)));
  }

  public readByDate(org: OrgDto, date: Date): Observable<WrapperDto<VatRateDto>> {
    const url = UrlBuilder.builder().addPath(this.allRead).addParam('orgId', org.id)
      .addQueryParams('date', date.toISOString()).build();
    return this.http.get<WrapperDto<VatRateDto>>(url.getUrl(), url.getOptions())
      .pipe(map((res) => new WrapperDto(res)));
  }

  public readType(org: OrgDto): Observable<WrapperDto<KeyValueDto>> {
    const url = UrlBuilder.builder().addPath(this.typeRead).addParam('orgId', org.id).build();
    return this.http.get<WrapperDto<KeyValueDto>>(url.getUrl(), url.getOptions())
      .pipe(map((res) => new WrapperDto(res)));
  }

  public update(org: OrgDto, vatRate: VatRateDto): Observable<WrapperDto<VatRateDto>> {
    const url = UrlBuilder.builder().addPath(this.futureCreate).addParam('orgId', org.id).build();
    return this.http.post<WrapperDto<VatRateDto>>(url.getUrl(), vatRate, url.getOptions())
      .pipe(map((res) => new WrapperDto(res)));
  }

  public delete(org: OrgDto, id: string): Observable<WrapperDto<VoidDto>> {
    const url = UrlBuilder.builder().addPath(this.futureDelete)
      .addParam('orgId', org.id).addParam('id', id).build();
    return this.http.post<WrapperDto<VoidDto>>(url.getUrl(), {}, url.getOptions())
      .pipe(map((res) => new WrapperDto(res)));
  }
}
